export default "__VITE_ASSET__BicpWkh7__"